export default "__VITE_ASSET__Bn_qgo2S__"